// extracted by mini-css-extract-plugin
export default {"wrapper":"promo-page_wrapper__s4FZ5"};